import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IProductLabelField {
  value: string;
  text: string;
}

interface IResponse {
  items: IProductLabelField[];
}

const getProductLabelFields = (): Promise<IResponse> =>
  axios.get('/dev-studio/process/product-label-fields');

export const useGetProductLabelFields = (
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['productLabelFields'],
    () => getProductLabelFields(),
    options
  );
